import keycloakService from '../keycloak_service';
import { sinatraOrigin } from '../config';

export const postToSinatra = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const sendRequestToKeycloak = (keycloakEndpoint = '', fetchOptions = {}) => {
  const keycloakOrigin = keycloakService.keycloak.authServerUrl;
  return fetch(`${keycloakOrigin}${keycloakEndpoint}`, fetchOptions)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Unexpected error with the following status code: ${response.status}`);
      }

      return response.json()
    }).catch(() => {
      throw new Error('An Unexpected error has occurred while trying to access keycloak.')
    })
}

export const putRequestToKeycloak = (keycloakEndpoint = '', fetchOptions = {}) => {
  const keycloakOrigin = keycloakService.keycloak.authServerUrl;
  return fetch(`${keycloakOrigin}${keycloakEndpoint}`, fetchOptions)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Unexpected error with the following status code: ${response.status}`);
      }

      // No content to return
      return {};
    }).catch(() => {
      throw new Error('An Unexpected error has occurred while trying to access keycloak.')
    })
}

export const deleteRequestToKeycloak = (keycloakEndpoint = '', fetchOptions = {}) => {
  const keycloakOrigin = keycloakService.keycloak.authServerUrl;
  return fetch(`${keycloakOrigin}${keycloakEndpoint}`, fetchOptions)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Unexpected error with the following status code: ${response.status}`);
      }

      // No content to return
      return {};
    }).catch(() => {
      throw new Error('An Unexpected error has occurred while trying to access keycloak.')
    })
}
